import React from "react";

const link = "techsg@shopee.com";
const Contact = () => (
  <section
    id="contact"
    style={{ backgroundImage: "Url(images/section-background-02.jpg)" }}
  >
    <div className="container">
      <p>Do you have any questions about Best Coder Campus?</p>
      <p>
        For partnership opportunities on tech related events, please email to:{" "}
        <a href={"mailto:" + link} className="link">
          {link}
        </a>
      </p>
      <a href={"mailto:" + link} className="btn btn-primary">
        Contact Us
      </a>
    </div>
  </section>
);

export default Contact;
